import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { useSearchParams } from '../../hooks/useSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchResultsHeader({
  parsedPath
}) {
  const searchParams = useSearchParams();
  if (searchParams.get('q')) {
    return /*#__PURE__*/_jsx(Text, {
      as: "h1",
      typography: "heading-400",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "marketplaceStorefront.searchResults.header.resultsForQuery_jsx",
        elements: {
          Strong: props => /*#__PURE__*/_jsx("span", Object.assign({
            style: {
              fontWeight: 700
            }
          }, props))
        },
        options: {
          query: searchParams.get('q')
        }
      })
    });
  }
  if (!parsedPath.category) {
    switch (parsedPath.productType) {
      case 'APP':
        return /*#__PURE__*/_jsx(Text, {
          as: "h1",
          typography: "heading-600",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.searchResults.header.allApps"
          })
        });
      case 'AGENT':
        return /*#__PURE__*/_jsx(Text, {
          as: "h1",
          typography: "heading-600",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.searchResults.header.allAgents"
          })
        });
      default:
        return /*#__PURE__*/_jsx(Text, {
          as: "h1",
          typography: "heading-600",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.searchResults.header.allProducts"
          })
        });
    }
  }
  return /*#__PURE__*/_jsx("div", {
    children: "TODO"
  });
}